import styled from "styled-components";

export const StyledHeader = styled.header`
  max-width: 100vw;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;

  .container {
    max-width: 1200px;
    width: 90%;
  }
  nav {
    display: flex;
    justify-content: flex-end;
    a {
      color: #999;
      transition: color 0.6s;
      margin-right: 4vw;
    }

    a:hover {
      color: black;
    }
  }
`;
